module.exports = __webpack_public_path__ + "img/frame06_stamp.51b317a6.png";